
import { useCallback, useEffect } from 'react';
import { Col, InputNumber, InputNumberValue, Row, Select, SelectValue, TagInput, TagInputValue } from 'tdesign-react';

import { IPhaseSelector, PhaseSelectorType } from '@/interface';

import styles from './styles/index.module.less';

interface IItemProps {
  value: IPhaseSelector;
  disabled?: boolean;
  options: { value: number, label: string; }[]
  onChange: (value: IPhaseSelector) => void
}

const Item = (props: IItemProps) => {
  const { value, disabled, options, onChange } = props;

  const handleChange1 = useCallback((val: SelectValue) => {
    if (value.type === PhaseSelectorType.PHASESELECTORTYPE_RANGE
      && Number(val) === PhaseSelectorType.PHASESELECTORTYPE_KEYWORDS) {
      onChange({
        type: Number(val),
        phaseIndex: value.phaseIndex,
        keywords: [],
      });
    }
    if (value.type === PhaseSelectorType.PHASESELECTORTYPE_RANGE
      && Number(val) === PhaseSelectorType.PHASESELECTORTYPE_RANGE) {
      onChange({
        type: Number(val),
        phaseIndex: value.phaseIndex,
        rangeMin: 0,
        rangeMax: 100,
      });
    }
  }, [value, onChange]);

  const handleChange2 = useCallback((val: InputNumberValue) => {
    if (value.type === PhaseSelectorType.PHASESELECTORTYPE_RANGE) {
      onChange({
        ...value,
        rangeMin: val as number,
      });
    }
  }, [value, onChange]);

  const handleChange3 = useCallback((val: InputNumberValue) => {
    if (value.type === PhaseSelectorType.PHASESELECTORTYPE_RANGE) {
      onChange({
        ...value,
        rangeMax: val as number,
      });
    }
  }, [value, onChange]);

  const handleChange4 = useCallback((val: TagInputValue) => {
    if (value.type === PhaseSelectorType.PHASESELECTORTYPE_KEYWORDS) {
      onChange({
        ...value,
        keywords: val.map(item => `${item}`),
      });
    }
  }, [value, onChange]);

  const handleChange5 = useCallback((val: SelectValue) => {
    onChange({
      ...value,
      phaseIndex: val as number,
    });
  }, [value, onChange]);

  useEffect(() => {
    const item = options.find(option => option.value === value.phaseIndex);
    if (!item) {
      onChange({ ...value, phaseIndex: 0 });
    }
  }, [options, value, onChange]);

  return <Row className={styles.root} gutter={[8, 8]}>
    <Col span={2}>
      <div className={styles.label}>触发方式</div>
      <Select
        value={value.type}
        disabled={disabled}
        options={[
          {
            value: PhaseSelectorType.PHASESELECTORTYPE_RANGE,
            label: '数值触发',
          },
          {
            value: PhaseSelectorType.PHASESELECTORTYPE_KEYWORDS,
            label: '关键词触发',
            disabled: true,
          },
        ]}
        onChange={handleChange1}
      />
    </Col>
    {value.type === PhaseSelectorType.PHASESELECTORTYPE_RANGE && <Col span={8}>
      <div className={styles.label}>数值范围</div>
      <div style={{ display: 'flex' }}>
        <InputNumber disabled={disabled}
          value={value.rangeMin} min={0} max={100} onChange={handleChange2} />
        <div style={{ margin: '0 4px' }}>-</div>
        <InputNumber disabled={disabled}
          value={value.rangeMax} min={0} max={100} onChange={handleChange3} />
      </div>
    </Col>}
    {value.type === PhaseSelectorType.PHASESELECTORTYPE_KEYWORDS && <Col span={8}>
      <div className={styles.label}>关键词</div>
      <TagInput disabled={disabled}
        value={value.keywords} onChange={handleChange4} /></Col>}
    <Col span={2}>
      <div className={styles.label}>切换人设</div>
      <Select
        disabled={disabled}
        value={value.phaseIndex}
        options={options}
        onChange={handleChange5}
      />
    </Col>
  </Row >;
};

export default Item;
